<template>
  <app-base-sheet ref="sheet">
    <template v-slot:title>Оберіть акцію</template>
    <template v-slot:content>
      <app-base-sheet-menu-item
        title="+1 місяць в подарунок"
        :image="menuImage1"
        @click="navigateTo('6-plus-1-promotion')"
      />
      <app-base-sheet-menu-item
        title="+3 місяці в подарунок"
        :image="menuImage2"
        @click="navigateTo('12-plus-3-promotion')"
      />
      <app-base-sheet-menu-item
        title="Приведи друга"
        :image="menuImage3"
        @click="navigateTo('refer-friend-promotion')"
        class="mb-0"
      />
    </template>
  </app-base-sheet>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { eventBus, events } from "@/eventBus";
import AppBaseSheet from "@/components/common/ui/AppBaseSheet.vue";
import AppBaseSheetMenuItem from "@/components/common/ui/AppBaseSheetMenuItem.vue";
import menuImage1 from "@/assets/promotions/banner-stock-1.jpg";
import menuImage2 from "@/assets/promotions/banner-stock-2.jpg";
import menuImage3 from "@/assets/promotions/banner-stock-3.jpg";

export default {
  name: "PromotionSheetComponent",
  components: {
    AppBaseSheet,
    AppBaseSheetMenuItem,
  },
  setup() {
    const sheet = ref(null);
    const router = useRouter();

    const navigateTo = (routeName) => {
      sheet.value?.close();
      router.push({ name: routeName });
    };

    onMounted(() => {
      eventBus.$on(events.OPEN_SHEET_PROMOTION, () => {
        sheet.value?.open();
      });
    });

    onUnmounted(() => {
      eventBus.$off(events.OPEN_SHEET_PROMOTION);
    });

    return {
      sheet,
      menuImage1,
      menuImage2,
      menuImage3,
      navigateTo,
    };
  },
};
</script>
